//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faMapMarker } from '@fortawesome/free-solid-svg-icons';
export default {
  props: {
    streetAddress: { type: String, default: null },
    city: { type: String, default: null },
    region: { type: String, default: null },
    postcode: { type: String, default: null },
    country: { type: String, default: null },
    countryCode: { type: String, default: null },
  },
  data: () => ({
    faMapMarker,
  }),
};
